const InviteRewardStatus = {
    kCannotGet: 1,
    kCanGet: 2,
    kRewarded: 3
}

const RewardType = {
    Box: 1,
    Invite: 2,
    FinalReward: 3,
    LastReward:4
}

/**
 * 活动状态
 */
const ActivityStatus = {
    kUnopen: 1, // 未开启
    kOpen: 2, // 开启中，可打关
    kReward: 3  // 活动结束，但可以拿大奖
}

/**
 * 广告类型枚举
 */
const AdType = {
    kMoreStep: 1,    // 更多页面
    kFail: 2,    // 失败加步数
}

module.exports = {
    InviteRewardStatus: InviteRewardStatus,
    RewardType: RewardType,
    ActivityStatus: ActivityStatus,
    AdType: AdType
}